/**
 * sopsView.ts — pure view-model helpers for Operations / SOPs (M1).
 *
 * The wire stores category as a lowercase slug (0099's CHECK, the stage-slug
 * posture); this module owns the display labels — the mockup's five picklist
 * options (klaxiora-crm-mockup-full.html :3063-3069) — and the card meta line
 * (":5009": category · owner · updated, dates in the mockup's en-GB long form,
 * :3540-3545).
 */
import type { OpsSop } from '../../types'

export const SOP_CATEGORIES = [
  { slug: 'onboarding', label: 'Onboarding' },
  { slug: 'escalation', label: 'Escalation' },
  { slug: 'equipment',  label: 'Equipment' },
  { slug: 'reporting',  label: 'Reporting' },
  { slug: 'other',      label: 'Other' },
] as const

export function sopCategoryLabel(slug: string): string {
  return SOP_CATEGORIES.find(c => c.slug === slug)?.label ?? slug
}

/** en-GB long date ("15 July 2026") — the mockup's formatCalDate. */
export function formatSopDate(iso: string): string {
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })
}

/** The card meta line: "Onboarding · Owner: Ada Owner · Updated 15 July 2026";
 *  '—' for an unassigned owner — never a fabricated name. */
export function sopMeta(sop: OpsSop): string {
  const owner = sop.assignedToName || '—'
  return `${sopCategoryLabel(sop.category)} · Owner: ${owner} · Updated ${formatSopDate(sop.updatedAt)}`
}

/** The header count line — the mockup's renderSopsList wording (:4993-4994). */
export function sopCountLine(n: number): string {
  return `${n} documented procedure${n !== 1 ? 's' : ''}.`
}
